import React, { useCallback, useEffect, useRef, useState } from 'react'

import { defaultToEmptyString } from '../../assets/ts/formatting/formatting'
import Badge from './badge'
import { PageHeaderProps } from './header.types'

const PageHeader = (props: PageHeaderProps) => {
  const [pageHeaderHeight, setPageHeaderHeight] = useState<number>(0)
  const headerRef = useRef<HTMLDivElement | null>(null)
  const handleResize = useCallback((entries: ResizeObserverEntry[]) => {
    for (const entry of entries) {
      if (entry.target instanceof HTMLElement) {
        const height = entry.target.offsetHeight
        setPageHeaderHeight(height)
      }
    }
  }, [])

  useEffect(() => {
    const headerElement = headerRef.current
    if (headerElement) {
      const resizeObserver = new ResizeObserver(handleResize)
      resizeObserver.observe(headerElement)

      // Clean up the observer on unmount
      return () => {
        resizeObserver.disconnect()
      }
    }
  }, [handleResize])

  useEffect(() => {
    // Update CSS variable when headerHeight changes
    document.documentElement.style.setProperty('--pageheader-height', `${pageHeaderHeight}px`)
  }, [pageHeaderHeight])

  return (
    <div
      className='py-2 px-3 whitebg shadow1 d-flex justify-content-between align-items-start align-items-sm-center flex-wrap sticky-lg-top w-100'
      data-pageheader='true'
      ref={headerRef}
    >
      <div className='d-flex align-items-center flex-wrap py-1'>
        {props?.name && (
          <div aria-label={props.name} className='d-flex align-items-center' tabIndex={0}>
            {props?.icon && <span className={props.icon}></span>}
            <h1
              aria-label={props.name}
              className={`poppins-semibold font-16 title-color40  ${props.titleclass}`}
              id={props?.id}
              tabIndex={0}
            >
              {defaultToEmptyString(props.name)}
            </h1>
            {props?.count && (
              <span
                aria-label={props?.count}
                className='bgcolor-primary border-radius3 px-2 py-1 font-12 whitetext poppins-semibold ms-1'
                tabIndex={0}
              >
                {defaultToEmptyString(props?.count)}
              </span>
            )}
            <Badge badge={props.badge} />
          </div>
        )}
        {props?.toolTip && props.toolTip}
      </div>
      <div className='d-flex flex-column flex-sm-row align-items-md-center w-100 maxfitcontent-sm ms-sm-auto'>
        <div className='d-flex flex-wrap flex-row justify-content-end gap-2'>
          {props.extras && props.extras}
        </div>
      </div>
    </div>
  )
}
export default PageHeader
